import { Link } from "react-router-dom";

export const FormHeaderNotAuth = ({
  title,
  subTitle,
  linkTitle,
  linkHref,
}: {
  title: string;
  subTitle?: string;
  linkTitle?: string;
  linkHref?: string;
}) => (
  <div className="px-2 md:px-0">
    <h1 className="text-500 font-bold text-black-100">{title}</h1>
    <div className="flex h-6 items-end justify-between pt-1">
      {subTitle && <span className="text-black-54">{subTitle}</span>}
      {linkTitle && linkHref && (
        <Link
          to={linkHref}
          className="text-300 font-bold text-secondary-100 hover:underline"
        >
          {linkTitle}
        </Link>
      )}
    </div>
  </div>
);
